//=============================================================================
//                       <--- Developed By Icon Team --->
//=============================================================================

// npm packages
import React, { useState, useEffect, useRef } from "react";
import { useLocation, useHistory } from "react-router-dom";
import i18n from "i18n";
import { useTranslation } from 'react-i18next';

// custom pages
import Logo from "assets/img/consent-logo.png";
import { consentStyles } from "../styles";
import auth from "apis/auth/auth";
import Loader from "components/Loader/CenteredLoader";
import TextField from "@material-ui/core/TextField";
import { withStyles } from "@material-ui/core/styles";
import Tier from "assets/img/Tier.JPG";

// material-ui
import Button from "@material-ui/core/Button";
import Card from "@material-ui/core/Card";
import KeyboardArrowDown from '@material-ui/icons/KeyboardArrowDown';
import Radio from '@material-ui/core/Radio';
import RadioGroup from '@material-ui/core/RadioGroup';
import FormControlLabel from '@material-ui/core/FormControlLabel';
// material-ui icons
import InfoOutlinedIcon from '@material-ui/icons/InfoOutlined';
import upgardeloyalty from 'apis/UpgradeLoyalty/upgardeloyalty';
import Newsignaturelogo from 'assets/img/Henry Schein Thrive Service plus.png';


export default function FormFour({ setNext, setStates, states,formData,links }) {



  const classes = consentStyles();
  const location = useLocation();
  const history = useHistory();
  const { t } = useTranslation();
  const param = new URLSearchParams(location.search);
  const token = param.get("token");
  const canvasRef = useRef(null);
  const ctxRef = useRef(null);
  const [isDrawing, setIsDrawing] = useState(false);
  const { getsericepluscreation } = upgardeloyalty();
  let country = localStorage.getItem('countryname')
  const {
    getLinks
  } = upgardeloyalty();
  const [ThriveServiceplus, setThriveServiceplus] = useState("");
  const [ThriveServiceplusprivacy, setThriveServiceplusprivacy] = useState("");
  const [ThriveServiceplustermcondition, setThriveServiceplustermcondition] = useState("");

  useEffect(() => {
    const fetchLinks = async () => {
      try {
        const response = await getLinks({ country: "us" });
        const linksData = response?.data || {};
        setThriveServiceplus(linksData.triveserviceplusLink);
        setThriveServiceplusprivacy(linksData.thriveserviceplusprivacyLink);
        setThriveServiceplustermcondition(linksData.thriveserviceplustermconditionLink);
      
      } catch (error) {
        console.error(error);
      }
    };
  
    fetchLinks(); // <--- important!
  }, []);
  
  
  

  useEffect(() => {
    const canvas = canvasRef.current;
    if (canvas) {
      canvas.width = 310;
      canvas.height = 114;
      const ctx = canvas.getContext("2d");
      ctx.strokeStyle = "black";
      ctx.lineWidth = 2;
      ctx.lineCap = "round";
      ctxRef.current = ctx;
      if (states?.signature) {
        const img = new Image();
        img.src = states?.signature;
        img.onload = () => {
          ctx.clearRect(0, 0, canvas.width, canvas.height);
          ctx.drawImage(img, 0, 0);
        };
      }
    }
  }, [states?.signature]);

  const handleMouseDown = (e) => {
    if (!ctxRef.current) return;
    ctxRef.current.beginPath();
    ctxRef.current.moveTo(e.nativeEvent.offsetX, e.nativeEvent.offsetY);
    setIsDrawing(true);
  };

  const handleMouseMove = (e) => {
    if (!isDrawing || !ctxRef.current) return;
    ctxRef.current.lineTo(e.nativeEvent.offsetX, e.nativeEvent.offsetY);
    ctxRef.current.stroke();
  };

  const isCanvasBlank = (canvas) => {
    const blank = document.createElement("canvas");
    blank.width = canvas.width;
    blank.height = canvas.height;
    return canvas.toDataURL() === blank.toDataURL();
  };

  const handleMouseUp = () => {
    if (!ctxRef.current) return;
    ctxRef.current.closePath();
    setIsDrawing(false);
  };
  

  const handleClear = () => {
    if (!ctxRef.current || !canvasRef.current) return;
    ctxRef.current.clearRect(0, 0, canvasRef.current.width, canvasRef.current.height);
    setStates({ signature: null });
  };

  

  const handleSave = () => {
    const canvas = canvasRef.current;
  if (!canvas) return;
    let error = false


    const dataURL = canvasRef.current.toDataURL("image/png");

    setStates({ signature: dataURL });
   
    if (isCanvasBlank(canvas)) {
      setStates({
        signatureerror: true
      })
      error = true
    }
    else {
      setStates({
        signatureerror: false
      })
      setNext('5')

    }
  
    // const dataURL = canvasRef.current.toDataURL("image/png");

    setStates({ signature: dataURL });
    localStorage.setItem("signature", dataURL)
  };
  
  

  
 
  // let ThriveSignature = 'https://www.henryschein.com/us-en/Dental/thrive/thrive-service-plus/thrive-service-plus.aspx'
  // let privacy = 'https://www.henryschein.com/us-en/Privacy.aspx'


  return (
    <div style={{ background: '#fff'}}>
       <img style={{ width: "100%" }} src={Newsignaturelogo}></img>
    <div style={{ width: '50%', margin: 'auto', marginRight: 'auto', background: '#fff', fontFamily: 'Inter, sans-serif', height: "100vh", display: "flex", flexDirection: "column", justifyContent: "center" }}>
      
      <div className={classes.textsig}>By clicking the "Enroll" button below, You agree: (i) to place this order and agree to the related terms electronically, and (ii) to the terms and conditions of the <a style={{ textDecoration: "underline" }} href={ThriveServiceplus} target="_blank"
                            rel="noopener noreferrer"> Thrive Service Plus Agreement. </a>For more information,Please read our <a style={{ textDecoration: "underline" }} href={ThriveServiceplusprivacy} target="_blank"
                            rel="noopener noreferrer"> Privacy Statement.  </a>
      </div>
      <div className={classes.textsig2} style={{ marginTop: 20 }} >Placing this order also includes your acceptance and agreement to our program <a style={{ textDecoration: "underline" }} href={ThriveServiceplustermcondition} target="_blank"
                            rel="noopener noreferrer">Terms and Conditions</a>.
        Please read them before placing this order. </div>
      <div>
        <div style={{ fontWeight: "bold", fontSize: "1.2em", marginTop: "25px", fontFamily: '"Inter", sans-serif' }}>
          Signature <span style={{ color: "red" }}>*</span>
        </div>
        <canvas
          ref={canvasRef}
          style={{ border: "1px solid rgba(195, 202, 216, 0.5)", cursor: "crosshair", marginTop: "10px" }}
          onMouseDown={handleMouseDown}
          onMouseMove={handleMouseMove}
          onMouseUp={handleMouseUp}
          onMouseLeave={handleMouseUp}
        />
        {states?.signatureerror && <div className={classes.errorTxt}><InfoOutlinedIcon
          className={classes.emailInputIcon}
        /><p>This field is required.</p></div>}
        {/* </div> */}
        <div style={{ marginTop: "5px" }}>

          <span role="button" onClick={handleClear} style={{ backgroundColor: "#eef3ff", padding: '4px 10px', borderRadius: 4, cursor: 'pointer', marginLeft: 257 }}>Clear</span>
        </div>
        <div style={{
          border: '1px solid transparent',
          borderTopColor: '#ededf1',
          marginTop: 20,
          paddingTop: 25,
          display: 'flex',
          justifyContent: 'space-between'
        }}>
          <button
            style={{
              float: 'right',
              border: '1px solid transparent',
              minWidth: '128px',
              height: '3em',
              color: '#000',
              borderRadius: 4,
              background: '#e5e7f2',
              cursor: 'pointer'
            }}
            onClick={() => setNext('3')}
          >Back
          </button>
          <button style={{
            float: 'right',
            border: '1px solid transparent',
            minWidth: '128px',
            height: '3em',
            color: '#fff',
            borderRadius: 4,
            background: '#2e69ff',
            cursor: 'pointer'

          }} onClick={() => handleSave()}
          
    >Next</button>
        </div>
      </div>
    </div>
    </div>
  );
}